



















































import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "user-logs-component",
})
export default class UserLogsComponent extends Vue {
  userLogs = [];
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  isCampusLogs = false;
  loader = false;

  mounted() {
    this.getUserLogs();
  }
  momentDate(date: string): string {
    return moment(date).format("MMMM DD YYYY, HH:mm");
  }
  changeToCampus() {
    this.currentPage = 1;
    this.lastPage = 1;
    this.userLogs = [];
    this.getUserLogs();
  }

  @Watch("currentPage")
  getUserLogs() {
    this.loader = true;
    if (this.isCampusLogs) {
      this.$store.dispatch("LogsStore/getUserLogsInCampusAction", {
        superSpaceId: this.$store.getters["SpaceStore/getSpace"].superSpace.id,
        page: this.currentPage,
        callback: (response) => {
          this.lastPage = parseInt(response.headers["pagination-last-page"]);
          this.itemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.userLogs = response.data;
          this.loader = false;
        },
      });
    } else {
      this.$store.dispatch("LogsStore/getUserLogsInSpaceAction", {
        spaceId: this.$store.getters["SpaceStore/getSpace"].id,
        page: this.currentPage,
        callback: (response) => {
          this.lastPage = parseInt(response.headers["pagination-last-page"]);
          this.itemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.userLogs = response.data;
          this.loader = false;
        },
      });
    }
  }
}
